<template>
    <div>
        <b-row class="report-ad-header-parent-row">
            <!-- Labels column -->
            <b-col cols="4">
                <b-row>
                    <p>Period:</p>
                </b-row>
                <b-row>
                    <p>Channel:</p>
                </b-row>
                <b-row>
                    <p>Film code:</p>
                </b-row>
                <b-row>
                    <p>Target group:</p>
                </b-row>
                <b-row>
                    <p>Advertiser:</p>
                </b-row>
                <b-row>
                    <p>Product:</p>
                </b-row>
                <b-row>
                    <p>Agency:</p>
                </b-row>
            </b-col>

            <!-- Values column -->
            <b-col cols="8">
                <b-row>
                    <div v-b-tooltip.hover="dateRange">
                        <p>{{ dateRange }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(providers)">
                        <p>{{ arrayToText(providers) }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(filmcodes)">
                        <p>{{ arrayToText(filmcodes) }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(targetGroups)">
                        <p>{{ arrayToText(targetGroups) }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(advertisers)">
                        <p>{{ arrayToText(advertisers) }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(products)">
                        <p>{{ arrayToText(products) }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div v-b-tooltip.hover.html="arrayToHtml(buyingAgencies)">
                        <p>{{ arrayToText(buyingAgencies) }}</p>
                    </div>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="!rofIsLoaded">
            <Spinner class="custom-spinner mt-5 ml-5" :loadingMsg="`Loading summary...`" />
        </b-row>
        <b-row class="measure-context-section report-ad-header-parent-row mt-4" v-else-if="rofIsLoaded">
            <!-- Labels column -->
            <b-col cols="5">
                <b-row class="mb-3">
                    <p>SUMMARY</p>
                </b-row>
                <b-row>
                    <p>Universe size</p>
                </b-row>
                <b-row>
                    <p>Panel size</p>
                </b-row>
                <b-row>
                    <p>Net Reach 1+</p>
                </b-row>
                <b-row>
                    <p>TRP</p>
                </b-row>
            </b-col>

            <!-- Values column -->
            <b-col cols="4" class="pl-5">
                <b-row class="mb-3">
                    <div>
                        <p>ABS 000s</p>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <p>{{ adsUniverseSize }}</p>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <p>{{ adsPanelSize }}</p>
                    </div>
                </b-row>
                <b-row class="d-flex">
                    <b-col class="d-flex px-0">
                        <p>{{ absoluteReach }}</p>
                    </b-col>
                </b-row>
                <b-row class="d-flex">
                    <b-col class="d-flex px-0">
                        <p>{{ totalTrpValue }}</p>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="3" class="pl-5">
                <b-row class="mb-3">
                    <div>
                        <p>REL</p>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <p></p>
                    </div>
                </b-row>
                <b-row>
                    <div>
                        <p></p>
                    </div>
                </b-row>
                <b-row class="d-flex justify-content-end">
                    <b-col class="d-flex px-0">
                        <p>{{ relativeReach }}</p>
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-between">
                    <b-col class="d-flex px-0">
                        <p>{{ totalTrpRelValue }}</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Spinner from "@/components/Shared/Spinner/Spinner"

export default {
    name: "ReportAdHeader",
    components: {
        Spinner,
    },
    props: {
        tableIsLoaded: {
            type: Boolean,
        },
    },
    data() {
        return {}
    },
    computed: {
        adsUniverseSize() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let universeSize = this.$store.getters.getAdsUniverseSize
                .map(element => {
                    if (element.split(";")[0] === chosenTargetGroup) return element.split(";")[1].replace(/\s/g, "")
                })
                .find(x => x)
            return universeSize > 0 ? universeSize / 1000 : universeSize
        },
        adsPanelSize() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let panelSize = this.$store.getters.getAdsPanelSize
                .map(element => {
                    if (element.split(";")[0] === chosenTargetGroup) return element.split(";")[1].replace(/\s/g, "")
                })
                .find(x => x)
            return panelSize
        },
        trpTotalMeasureKey() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let measures = this.$store.getters.getAdsCampaignReportQuery.measures
            let trpTotalKey = measures.reduce((pre, m, index) => {
                let ageText = m.selectedMeasureText.subHeader.replace(/\s.*/, "")
                if (!pre && m.source === "Total" && m.measure === "trp" && ageText === chosenTargetGroup) {
                    return `measure_${index + 1}`
                }
                return pre
            }, null)
            return trpTotalKey
        },
        reachTotalMeasureKey() {
            let chosenTargetGroup = this.$store.getters.getAdsCampaignReportCurrentTargetGroup
            let measures = this.$store.getters.getAdsCampaignReportQuery.measures
            let trpTotalKey = measures.reduce((pre, m, index) => {
                let ageText = m.selectedMeasureText.subHeader.replace(/\s.*/, "")
                if (!pre && m.source === "Total" && m.measure === "reach" && ageText === chosenTargetGroup) {
                    return `measure_${index + 1}`
                }
                return pre
            }, null)
            return trpTotalKey
        },
        totalReachValue() {
            let reachTotalKey = this.reachTotalMeasureKey
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[reachTotalKey]
        },
        totalReachRelValue() {
            let reachTotalRelKey = `${this.reachTotalMeasureKey}_rel`
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[reachTotalRelKey]
        },
        totalTrpValue() {
            let trpTotalKey = this.trpTotalMeasureKey
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[trpTotalKey]
        },
        totalTrpRelValue() {
            let trpRelTotalKey = `${this.trpTotalMeasureKey}_rel`
            let summaryRow = this.$store.getters.getAdsCampaignReportResults.data[this.$store.getters.getAdsCampaignReportMeasureSumMode.key]?.totalRow
            return summaryRow[trpRelTotalKey]
        },
        dateRange() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.dateRange) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.dateRange
            }
            return "n/a"
        },
        providers() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.providers?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.providers
            }
            return []
        },
        filmcodes() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.filmCodes?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.filmCodes
            }
            return []
        },
        targetGroups() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.targetGroups?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.targetGroups
            }
            return []
        },
        advertisers() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.advertisers?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.advertisers
            }
            return []
        },
        products() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.products?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.products
            }
            return []
        },
        buyingAgencies() {
            if (this.$store.getters.getAdsCampaignReportQuery?.headerData?.buyingAgencies?.length > 0) {
                return this.$store.getters.getAdsCampaignReportQuery.headerData.buyingAgencies
            }
            return []
        },
        rofIsLoaded() {
            return this.$store.getters.getAdsCampaignReportResults.data.RoF.status === "LOADED"
        },
        currentTargetGroup() {
            return this.$store.getters.getAdsCampaignReportCurrentTargetGroup;
        },
        currentRoFData() {
            const rofData = this.$store.getters.getAdsCampaignReportResults.data.RoF.rofMeasures.find(r => r.targetGroup === this.currentTargetGroup)
            return rofData ? rofData.measures : { relativeReach: "n/a", absoluteReach: "n/a" }
        },
        absoluteReach() {
            return this.currentRoFData.absoluteReach
        },
        relativeReach() {
            return this.currentRoFData.relativeReach
        }
    },
    methods: {
        arrayToText(array) {
            if (array?.length < 1 || array[0] === "-") return "-"
            let text = array.length < 2 ? array[0] : array.join(", ")
            if (text.length > 30) {
                return text.substring(0, 27) + `...(${array.length})`
            }
            return text
        },
        arrayToHtml(array) {
            if (array?.length < 1 || array[0] === "-") return ""
            if (array.length < 2) return array[0]
            let html = array.join("<br> ")
            return html
        },
    },
}
</script>

<style scoped>
.report-ad-header-parent-row {
    margin: 0;
}
.row:not(.report-ad-header-parent-row) {
    height: 1.5rem !important;
    white-space: nowrap;
}
.measure-context-section {
    background-color: #337ab7;
    color: white;
    font-weight: bold;
    padding: 1rem;
    border-radius: 5px;
    margin-right: -0.5rem;
}
.custom-spinner {
    font-size: 1rem;
}
</style>
